import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import CollectionPointList from '@/views/collectionPoint/List.vue';

export const collectionPointRoute: RouteConfig = {
  path: 'collectionPoints',
  name: 'collectionPoints',
  component: CollectionPointList,
  beforeEnter: (to, from, next) => {
    store.dispatch('access/check', ['COLLECTION_POINT.UPDATE']).then(permissions => {
      console.log(permissions);
      if (!permissions[0]) {
        next({ name: 'profile' });
      }
      store
        .dispatch('collectionPoint/list', baseFilters(to))
        .then(() => {
          store.commit('breadcrumbs/set', [{ text: 'Punkty odbioru', disabled: true }]);
          next();
        })
        .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać punktów odbioru.' }));
    });
  },
  meta: { toolbarTitle: 'Punkty odbioru fizycznej karty' }
};
